<script setup lang="ts">
import { api } from '@/api';
import SubmitButton from '@/components/forms/SubmitButton/SubmitButton.vue';
import TextField from '@/components/forms/TextField/TextField.vue';
import SimplePage from '@/components/pages/SimplePage/SimplePage.vue';
import { ForgotPasswordViewProps } from '@/views/ForgotPasswordView/types.ts';
import { ref } from 'vue';

const props = defineProps<ForgotPasswordViewProps>();

const completed = ref(false);
const isSubmitting = ref(false);
const email = ref(props.email || '');
const showError = ref(props.error === 'true');

async function onSubmit() {
  isSubmitting.value = true;
  showError.value = false;
  const { success } = await api.account.sendResetPasswordLink({
    email: email.value,
  });
  if (success) {
    completed.value = true;
  }
  isSubmitting.value = false;
}
</script>

<template>
  <template v-if="completed">
    <SimplePage :headline="$t('CheckYourEmail')">
      <p class="text-pre-line">
        {{ $t('ResetPasswordInstructionsSentMsg') }}
      </p>
    </SimplePage>
  </template>
  <template v-else>
    <SimplePage :headline="$t('ForgotPassword')">
      <v-alert
        v-if="showError"
        class="text-pre-line"
        density="compact"
        type="warning"
        variant="flat"
        :icon="false"
      >
        {{ $t('ResetPasswordLinkExpiredMsg') }}
      </v-alert>
      <p v-else class="text-pre-line">
        {{ $t('EnterEmailForResetPasswordInstructionsMsg') }}
      </p>
      <form class="form mt-6" @submit.prevent="onSubmit">
        <TextField v-model="email" :label="$t('Email')" class="mb-2" />
        <SubmitButton
          class="mt-6"
          :block="true"
          :text="$t('SendInstructions')"
          :loading="isSubmitting"
          :disabled="!Boolean(email)"
        />
      </form>
    </SimplePage>
  </template>
</template>

<style lang="scss" scoped>
@use '@/styles/variables';
.form {
  max-width: variables.$maxSimpleLayoutFormWidth;
  margin: 0 auto;
  text-align: left;
}
</style>
